export default __webpack_public_path__ + "static/logo-f9c6e7218f36b3b6d6d83db4ed8b90ea.svg";